import { isDuetDateValidFunction as isDuetDateValid } from "./duet-date-picker";

global.CrossratesAstrid = (function ($) {
	function init() {
		const form = document.getElementById('riksbank-seriesform');
		const $showMoreButton = $('.cross-rate__add-more');
		const $deleteButton = $('.cross-rate__delete');
		const hiddenClass = 'cross-rate--hidden';
		const selects = document.querySelectorAll('.select-cross-rates');
		const submitFormBtn = document.getElementById('submit');
		const formError = document.getElementById('form-error');

		$showMoreButton.on('click', function () {
			if ($('html').hasClass('user-is-tabbing') === false) {
				$(this).blur();
			}
			showOneMoreCrossRateInputs();
		});

		$deleteButton.on('click', function (event) {
			deleteCrossRate(this, event);
			if (hasHiddenInputs()) {
				$showMoreButton.removeClass("visually-hidden");
				$showMoreButton.attr("aria-hidden","false");
			}
		});

		if (hasHiddenInputs()) {
			$showMoreButton.removeClass("visually-hidden");
			$showMoreButton.attr("aria-hidden","false");
		}

		selects.forEach(el => el.addEventListener('change', event => {
			let selectTrigger = el;
			let selectedIndex = el.options.selectedIndex;
			let selectedGroup = event.target.dataset.group
			let select_a_targetList = document.querySelectorAll('[id^="cpa"]');
			let select_b_targetList = document.querySelectorAll('[id^="cpb"]');
			let select_a_target = select_a_targetList[selectedGroup];
			let select_b_target = select_b_targetList[selectedGroup];
			showDomElement(formError, false);

			if(select_a_target.id == selectTrigger.id) {
				handleSelectIndex(select_b_target, selectedIndex);
			}

			if(select_b_target.id == selectTrigger.id) {
				handleSelectIndex(select_a_target, selectedIndex);
			}
		}));

		function showDomElement(e, state) {
			if(state === true) {
				e.classList.remove("visually-hidden");
				e.ariaHidden = "false"
			} else {
				e.classList.add("visually-hidden");
				e.ariaHidden = "true"
			}
		}

		function handleSelectIndex(target, selectedIndex) {
			for (var i = 0; i < target.options.length; i++) {
				var option = target.options[i];
				option.style = '';
				option.ariaHidden = "false";
			}

			if(selectedIndex > 0) {
				target.options[selectedIndex].style.display = 'none';
				target.options[selectedIndex].ariaHidden = "true";
			}
		}

		function deleteCrossRate(context, event) {
			$(context).parent().addClass(hiddenClass);
			$(context).parent().attr("aria-hidden","true");
			const $crossRatesHidden = $('.cross-rate--hidden');

			$crossRatesHidden.each(function (index) {
				var $this = $(this);
				var $select = $this.find('select.select-cross-rates');

				$select.each(function () {
					$(this).val("");
				 });
			});
		}

		function showOneMoreCrossRateInputs() {
			$('.' + hiddenClass).first().attr("aria-hidden","false");
			$('.' + hiddenClass).first().removeClass(hiddenClass);

			if (hasHiddenInputs() === false) {
				$showMoreButton.addClass("visually-hidden");
				$showMoreButton.attr("aria-hidden","true");
			}
		}

		function hasHiddenInputs() {
			return $('.' + hiddenClass).length > 0;
		}

		if (form) {
			form.onclick = function (event) {
				let dd1 = document.getElementById('cpa_0');
				let dd2 = document.getElementById('cpb_0');
				showDomElement(formError, false);

				if (submitFormBtn && event.target.id.toString() === "submit") {

					if(dd1 !== null) {
						if(dd1.selectedIndex !== 0 && dd2.selectedIndex !== 0 ) {
							return true;
						}

						event.preventDefault();
						showDomElement(formError, true);
						formError.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });

					} else {
						if(isDuetDateValid()) {
							return true;
						}

						event.preventDefault();
						showDomElement(formError, true);
						formError.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
					}
				}
			}
		}

		const separator = document.getElementById("separator");
		if (separator) {
			separator.addEventListener('click', function (event) {
				if (event.target && event.target.matches("input[type='radio']")) {
					let val = event.target.value;
					setSeparator(val);
					setDownloadLink(val)
				}
			});

			let dlLinks = document.querySelectorAll(".dl_link a");
			let cells = document.querySelectorAll(".swea-table td.res span.sep");

			function setDownloadLink(val) {
				for (let dlLink of dlLinks) {
					let getLink = dlLink.getAttribute("href");
					const newLink = val === "Dot" ? getLink.replace('Comma', 'Dot') : getLink.replace('Dot', 'Comma');
					dlLink.setAttribute("href", newLink);
				}
			}

			function setSeparator(val) {
				for (let cell of cells) {
					const separator = val === "Dot" ? "." : ",";
					cell.innerHTML = separator.toString();
				}
			}
		}

	}

	return {
		init: init
	};

})(jQuery);
